import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type AuthState = {
  token: string | null;
  user: null | User;
  dsp: null | DSP;
};

const initialState: AuthState = {
  user: null,
  token: null,
  dsp: null,
};

const slice = createSlice({
  initialState,
  name: "auth",
  reducers: {
    addToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    signIn(state, action: PayloadAction<{ user: User; dsp: DSP }>) {
      state.user = action.payload.user;
      state.dsp = action.payload.dsp;
    },
    signOut(state) {
      state.token = null;
      state.user = null;
      state.dsp = null;
    },
  },
});

export default slice.reducer;
export const { addToken, signIn, signOut } = slice.actions;
